import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';

export interface IErrorBarProps {
  ErrorMessage: string,
  _onDismiss(): void
}

export interface IErrorBarState {
}

export default class ErrorBar extends React.Component<IErrorBarProps, IErrorBarState> {
  constructor(props: IErrorBarProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <div className="container">
        {this.props.ErrorMessage != "" && <MessageBar messageBarType={MessageBarType.error} isMultiline={false}
          onDismiss={this.props._onDismiss}
          dismissButtonAriaLabel="Sluiten" >
          {this.props.ErrorMessage}
        </MessageBar>}
      </div>
    );
  }
}
